import { media } from '@mnd-frontend/ui/publish/utils';
import { GREY_200, GREY_300, SPACING_3, SPACING_4 } from '@mnd-frontend/ui/shared/tokens';
import Debug from 'debug';
import type { ReactNode } from 'react';
import styled, { createGlobalStyle, css } from 'styled-components';
import UnscheduleRelatedMaterialModal from '../../../../components/UnscheduleRelatedMaterialModal';
import { useHiddenMenu } from '../../../../contexts/HiddenMenuContext';
import { SITE_CONTENT_RADIUS } from '../../../../lib/constants';
import Navigation from '../Navigation';
import NotLiveAlert from '../NotLiveAlert';
import SystemDialog from '../SystemDialog';
import Widgets from '../Widgets';

const GlobalStyles = createGlobalStyle`
  body {
    background-color: ${GREY_300};
  }
`;

if (typeof window !== 'undefined') {
  // eslint-disable-next-line no-underscore-dangle
  window.__debug = Debug;
}

const HeaderAndSiteContentWrapper = styled.div<{ $menuHidden: boolean }>`
  ${media.greaterThan('navigationBreakpoint')} {
    display: grid;
    grid-template-columns: ${({ $menuHidden }) =>
      $menuHidden ? '1fr' : 'var(--mnd-navigation-width) 1fr'};
    grid-template-rows: unset;
    min-height: 100%;
    margin: ${SPACING_3} ${SPACING_3} ${SPACING_3} 0;
    > * {
      min-width: 0;
    }
  }
`;

const SiteOverlays = styled.div`
  position: relative;
`;

const SiteContent = styled.div<{ $menuHidden: boolean }>`
  ${props =>
    !props.$menuHidden
      ? css`
          background-color: ${GREY_200};
          --current-background: ${GREY_200};
          min-height: 100vh;
          ${media.greaterThan('navigationBreakpoint')} {
            border-radius: ${SITE_CONTENT_RADIUS};
            padding-bottom: ${SPACING_4};
          }
          main {
            min-height: 100%;
            padding: 5rem 1rem;
            ${media.greaterThan('navigationBreakpoint')} {
              padding: 4rem 1rem 0;
            }
          }
        `
      : css`
          position: relative;
        `}
`;

const AppContainer = ({
  children,
  isMynewsdeskAdmin,
  forceHideMenu,
  pressroomId,
  sourceId,
  isDisabledForTrialExpiredUsers,
}: {
  children: ReactNode;
  isMynewsdeskAdmin: boolean | undefined;
  forceHideMenu: boolean;
  pressroomId?: string;
  sourceId?: string;
  isDisabledForTrialExpiredUsers?: boolean;
}) => {
  const { menuHidden } = useHiddenMenu();

  return (
    <>
      <GlobalStyles />
      <SiteOverlays>
        <SystemDialog />
        <UnscheduleRelatedMaterialModal />
      </SiteOverlays>
      {forceHideMenu ? (
        children
      ) : (
        <HeaderAndSiteContentWrapper $menuHidden={menuHidden}>
          {!menuHidden && (
            <Navigation
              sourceId={sourceId}
              pressroomId={pressroomId}
              isMynewsdeskAdmin={isMynewsdeskAdmin}
            />
          )}
          <SiteContent $menuHidden={menuHidden}>
            {!isDisabledForTrialExpiredUsers && pressroomId && (
              <NotLiveAlert pressroomId={pressroomId} />
            )}
            {children}
            {!isDisabledForTrialExpiredUsers && <Widgets />}
          </SiteContent>
        </HeaderAndSiteContentWrapper>
      )}
    </>
  );
};

export default AppContainer;
